import NotEnoughSeats from "features/subscriptions/components/NotEnoughSeatsDialog";

import { LinkedInLoginModal } from "common/components/LinkedInLogin";
import type { WorkspaceAccount } from "common/types";

import AssignSeatModal from "./AssignSeatModal";
import ManageAccountsModal from "./ManageAccountsModal";

interface ActionModalProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  selectedAccount?: WorkspaceAccount;
  type: "add" | "remove" | "reconnect" | "license" | "assignSeat";
}

export default function ActionModal({
  type,
  isOpen,
  setIsOpen,
  selectedAccount = null,
}: ActionModalProps) {
  if (type === "reconnect")
    return (
      <LinkedInLoginModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        account={selectedAccount}
      />
    );

  if (type === "license") {
    return (
      <NotEnoughSeats
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        noSeatAccountIds={[selectedAccount.id]}
      />
    );
  }

  if (type === "assignSeat") {
    return (
      <AssignSeatModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        account={selectedAccount}
      />
    );
  }

  return (
    <ManageAccountsModal
      isOpen={isOpen}
      actionType={type}
      onClose={() => setIsOpen(false)}
    />
  );
}
